import { type ColumnMap, type User, type UserMap } from "./CrewTransfer.model";

export const getMaps = (
  data: any[],
): { users: UserMap; columns: ColumnMap; columnOrder: string[] } => {
  const columns: ColumnMap = {};
  const userMap: UserMap = {};

  data.forEach((userRes: any) => {
    const { yachtid, yachtname, content } = userRes.data;
    const users = content.users
      ? content.users.map((user: any) => ({
          id: user.userid,
          username: user.full_name,
          role: user.rolename,
        }))
      : [];

    users.forEach((u: User) => {
      userMap[u.id] = u;
    });

    columns[yachtid] = {
      id: yachtid,
      title: yachtname,
      userIds: users.map((u: User) => u.id),
    };
  });

  return { users: userMap, columns, columnOrder: Object.keys(columns) };
};
